import axios from '../axios';

class Api {
    static getListBedrijf (zoekstring) {
        return axios.get(`/bedrijf/list?zoekstring=${zoekstring}`);
    }

    static getDetailBedrijf (id) {
        return axios.get(`/bedrijf/detail/${id}`);
    }

    static addBedrijf (payload) {
        return axios.post('/bedrijf', payload);
    }

    static updateBedrijf (payload) {
        return axios.post(`/bedrijf/update/${payload.id}`, payload);
    }

    static deleteBedrijf (payload) {
        return axios.post(`/bedrijf/delete/${payload}`);
    }

    static destroyBedrijf (payload) {
        return axios.post(`/bedrijf/destroycomplete/${payload}`);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/bedrijf.js